module.exports = __webpack_public_path__ + "static/media/IMG_2188.02ed4d26.jpg";